module.exports = __webpack_public_path__ + "img/coming-soon.caf6cd1a.svg";